<template>
	<c-dialog ref="dialog" title="调用日志详情" mode="slide" width="55vw" mask-close :button="false">
		<div class="m-api-log-detail">
			<c-title>基础信息</c-title>
			<c-detail class="m-detail-table" column="2">
				<c-detail-item label="接口名称" colspan="2">{{row.api_name || '-'}}</c-detail-item>
				<c-detail-item label="调用方向">
					<span>{{directionText(row.direction)}}</span>
				</c-detail-item>
				<c-detail-item label="调用结果">
					<span :style="{color: row.process_result == 2 ? '#e53e3e' : '#07b461'}">{{resultText(row.process_result)}}</span>
				</c-detail-item>
				<c-detail-item label="渠道">{{platformMap[row.channel_code] || row.channel_code || '-'}}</c-detail-item>
				<c-detail-item label="渠道场景">{{channelSceneMap[row.channel_scene] || row.channel_scene || '-'}}</c-detail-item>
				<c-detail-item label="渠道商品ID">{{row.biz_product_id || '-'}}</c-detail-item>
				<c-detail-item label="ERP商品ID">{{row.product_id || '-'}}</c-detail-item>
				<c-detail-item label="渠道订单号" colspan="2">{{row.biz_order_id || '-'}}</c-detail-item>
				<c-detail-item label="调用方法">{{row.method_key || '-'}}</c-detail-item>
				<c-detail-item label="消息队列">{{row.queue_key || '-'}}</c-detail-item>
				<c-detail-item label="链路追踪号">{{row.trace_id || '-'}}</c-detail-item>
				<c-detail-item label="请求来源IP">{{row.request_ip || '-'}}</c-detail-item>
				<c-detail-item label="处理耗时(ms)">{{row.cost_time == null ? '-' : row.cost_time}}</c-detail-item>
				<c-detail-item label="创建时间">{{row.create_date || '-'}}</c-detail-item>
				<c-detail-item label="失败原因" colspan="2">{{row.fail_message || '-'}}</c-detail-item>
			</c-detail>

			<c-title>报文数据</c-title>
			<div class="m-code-block" v-for="block in codeBlocks" :key="block.label">
				<div class="m-code-head">
					<span class="m-code-label">{{block.label}}</span>
					<c-button v-if="block.value" color="sys" @click="copyText(block.value)">复制</c-button>
				</div>
				<pre class="m-code-pre">{{block.value || '-'}}</pre>
			</div>
		</div>
	</c-dialog>
</template>

<script>
export default {
	name: 'maintenanceApiCallLogDetail',

	data() {
		return {
			row: {},
			platformMap: {},  // 平台代码→平台名称映射
			channelSceneMap: {
				'CHX_DARK_AUCTION': '采货侠暗拍',
				'CHX_QUALITY_DEVICE': '采货侠靓机',
				'CHX_REVERSE_DARK_AUCTION': '采货侠反向暗拍',
				'CHX_REVERSE_QUALITY_DEVICE': '采货侠反向靓机',
				'GOOFISH_DARK_AUCTION': '闲鱼暗拍',
				'GOOFISH_QUALITY_DEVICE': '闲鱼靓机',
				'GOOFISH_STRICT_SELECTION': '闲鱼严选',
				'JD_DEFAULT': '京东严选',
				'TY_DEFAULT': '天翼商城',
				'ZZ_DEFAULT': '转转严选',
				'XIAOHEI_QUALITY_DEVICE': '小黑靓机',
				'XIAOHEI_DARK_AUCTION': '小黑暗拍'
			}
		}
	},

	computed: {
		codeBlocks() {
			return [
				{label: '请求报文', value: this.formatJson(this.row.content_data)},
				{label: '响应报文', value: this.formatJson(this.row.response_data)},
				{label: '异常堆栈', value: this.row.stack_trace}
			];
		}
	},

	methods: {
		/*********打开抽屉（按id拉取详情）**********/
		open(id) {
			if (!id) return;
			this.row = {};
			this.$refs.dialog.open();
			this.loadPlatformMap();
			this.request({
				url: '/maintenance/api-call-log/detail',
				data: {id},
				loading: true,
				success: data => {
					this.row = data || {};
				}
			});
		},

		/*********加载平台映射（用于渠道翻译）**********/
		loadPlatformMap() {
			this.request({
				url: '/channel/list',
				data: {},
				success: data => {
					const platformMap = {};
					(data || []).forEach(item => {
						if (item.platform_code && !platformMap[item.platform_code]) {
							platformMap[item.platform_code] = item.platform_name || item.platform_code;
						}
					});
					this.platformMap = platformMap;
				}
			});
		},

		/*********JSON美化（非JSON原样返回）**********/
		formatJson(text) {
			if (text === null || text === undefined || text === '') return '';
			try {
				return JSON.stringify(JSON.parse(text), null, 2);
			} catch (e) {
				return text;
			}
		},

		/*********复制到剪贴板**********/
		copyText(text) {
			const value = text == null ? '' : String(text);
			if (navigator.clipboard && navigator.clipboard.writeText) {
				navigator.clipboard.writeText(value).then(() => {
					this.$message({message: '已复制', icon: 'success'});
				});
				return;
			}
			const textarea = document.createElement('textarea');
			textarea.value = value;
			textarea.style.position = 'fixed';
			textarea.style.opacity = '0';
			document.body.appendChild(textarea);
			textarea.select();
			try {
				document.execCommand('copy');
				this.$message({message: '已复制', icon: 'success'});
			} catch (e) {
				this.$message({message: '复制失败，请手动选择'});
			}
			document.body.removeChild(textarea);
		},

		/*********字典文案**********/
		directionText(v) {
			if (v == 1) return '小黑中台→ERP';
			if (v == 2) return 'ERP→小黑中台';
			return '-';
		},
		resultText(v) {
			if (v == 1) return '成功';
			if (v == 2) return '失败';
			return '-';
		}
	}
}
</script>

<style scoped>
.m-api-log-detail {
	padding: 0 20px 20px;
}

.m-detail-table ::v-deep .c-detail-item-label {
	background-color: #fafafa;
	color: #666;
	text-align: right;
}

.m-code-block {
	margin-bottom: 16px;
}

.m-code-head {
	display: flex;
	justify-content: space-between;
	align-items: center;
	margin-bottom: 6px;
}

.m-code-label {
	font-size: 13px;
	font-weight: bold;
	color: #333;
}

.m-code-pre {
	background-color: #f6f8fa;
	border: 1px solid #e1e4e8;
	border-radius: 4px;
	padding: 12px;
	margin: 0;
	max-height: 320px;
	overflow: auto;
	white-space: pre-wrap;
	word-break: break-all;
	font-family: Consolas, Monaco, monospace;
	font-size: 12px;
	line-height: 1.5;
	color: #24292e;
}
</style>
